import React from 'react'
import { connect } from 'react-redux'

import MainWrapper from './wrappers/main'

// Pages
import { CookiePolicy, DataProcessingAgreement, PrivacyPolicy, TermsOfUse, Policy } from '../pages/policy'
import Home from '../pages/Home'
import About from '../pages/About'
import Contacts from '../pages/Contacts'
import Investors from '../pages/Investors'
import HowItWorks from '../pages/HowItWorks'
import Pricing from '../pages/Pricing/Pricing'
import TemplateGallery from '../pages/TemplateGallery/TemplateGallery'
import Landing from '../pages/Landing/index'
import PageNotFound from '../pages/PageNotFound'

class MainCommonRoutes extends React.Component {
    state = {}

    componentDidMount() {}
    componentWillUnmount() {}

    render() {
        return (
            // <Suspense fallback={<></>}>
            <>
                <MainWrapper exact path="/" component={Home} />
                <MainWrapper exact path="/template-gallery/:id?" component={TemplateGallery} />
                <MainWrapper exact path="/about" component={About} />
                <MainWrapper exact path="/contacts" component={Contacts} />
                <MainWrapper exact path="/investors" component={Investors} />
                <MainWrapper exact path="/how-it-works" component={HowItWorks} />
                <MainWrapper exact path="/pricing/:type" component={Pricing} />
                <MainWrapper exact path="/cookie-policy" component={CookiePolicy} />
                <MainWrapper exact path="/data-processing-agreement" component={DataProcessingAgreement} />
                <MainWrapper exact path="/privacy-policy" component={PrivacyPolicy} />
                <MainWrapper exact path="/terms-of-use" component={TermsOfUse} />
                <MainWrapper exact path="/policy" component={Policy} />
                <MainWrapper exact path="/products/:name" component={Landing} />
                <MainWrapper exact path="/404" component={PageNotFound} />
            </>
            // </Suspense>
        )
    }
}

export default connect(null, null)(MainCommonRoutes)
